import './portfolio.scss'
import { SiJavascript, SiExpress, SiMongodb, SiCss3, SiRedux, SiVite, SiGithub, SiPostman, SiNpm, SiHeroku, SiNetlify } from "react-icons/si";
import { FaNodeJs, FaDatabase, FaSass, FaReact, FaGitAlt } from "react-icons/fa";
import { AiOutlineCluster, AiFillHtml5 } from "react-icons/ai";

export const Portfolio = () => {

  return (
    <div className="portfolio" id="portfolio">
      <h1>Skills & Tools</h1>
      
      <div className="container">
        {/* backend */}
        <div className="item">
            <SiJavascript className="logo_js"/>
            <h3>JavaScript</h3>
        </div>
        <div className="item">
            <SiExpress className="logo_js"/>
            <h3>Express</h3>
        </div><div className="item">
            <FaNodeJs className="logo_js"/>
            <h3>NodeJs</h3>
        </div><div className="item">
            <SiMongodb className="logo_js"/>
            <h3>Mongodb</h3>
        </div><div className="item">
            <AiOutlineCluster className="logo_js"/>
            <h3>Cluster</h3>
        </div><div className="item">
            <FaDatabase className="logo_js"/>
            <h3>Database</h3>
        </div>
        {/* FrontEnd */}
        <div className="item">
            <AiFillHtml5 className="logo_js"/>
            <h3>Html5</h3>
        </div>
        <div className="item">
            <SiCss3 className="logo_js"/>
            <h3>Css3</h3>
        </div><div className="item">
            <FaSass className="logo_js"/>
            <h3>Sass</h3>
        </div><div className="item">
            <FaReact className="logo_js"/>
            <h3>React</h3>
        </div><div className="item">
            <SiRedux className="logo_js"/>
            <h3>Redux</h3>
        </div><div className="item">
            <SiVite className="logo_js"/>
            <h3>Vite</h3>
        </div>
        {/* Tools */}
        <div className="item">
            <SiGithub className="logo_js"/>
            <h3>Github</h3>
        </div>
        <div className="item">
            <FaGitAlt className="logo_js"/>
            <h3>GitBash</h3>
        </div><div className="item">
            <SiPostman className="logo_js"/>
            <h3>Postman</h3>
        </div><div className="item">
            <SiNpm className="logo_js"/>
            <h3>Npm</h3>
        </div><div className="item">
            <SiHeroku className="logo_js"/>
            <h3>Heroku</h3>
        </div><div className="item">
            <SiNetlify className="logo_js"/>
            <h3>Netlify</h3>
        </div>
      </div>
    </div>
  )
}
